import * as types from './CurrentUserTypes'

export const fetchMe = req => ({ type: types.GET_ME, req })
